import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'nps.title',
    defaultMessage: 'How likely are you to recommend XCover to a friend or colleague?',
  },
  negativeText: {
    id: 'nps.negativeText',
    defaultMessage: 'Not likely',
  },
  positiveText: {
    id: 'nps.positiveText',
    defaultMessage: 'Very likely',
  },
  feedbackLeadText: {
    id: 'nps.feedbackLeadText',
    defaultMessage: `We’re sorry we didn’t meet your expectations. Would you like to share your feedback to help us improve?`,
  },
  feedbackRequireText: {
    id: 'nps.feedbackRequireText',
    defaultMessage: 'Please provide your feedback above.',
  },
  feedbackPlaceholder: {
    id: 'nps.feedbackPlaceholder',
    defaultMessage: 'Provide feedback',
  },
  submitFeedbackText: {
    id: 'nps.submitFeedbackText',
    defaultMessage: 'Provide feedback',
  },
  reviewLeadText: {
    id: 'nps.reviewLeadText',
    defaultMessage:
      'It’s great to hear that you enjoyed your experience with us. We’d be very grateful if you left a review and shared your thoughts with others.',
  },
  reviewButtonText: {
    id: 'nps.reviewButtonText',
    defaultMessage: 'Leave us a review',
  },
  feedbackGiven: {
    id: 'nps.feedbackGiven',
    defaultMessage: 'Thanks for providing your feedback.',
  },
});
